
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SearchPage from "../pages/search/page";
import ProjectsPage from "../pages/projects/page";
import TalentsPage from "../pages/talents/page";
import ClientsPage from "../pages/clients/page";
import ManagementPage from "../pages/management/page";
import CommunicationPage from "../pages/communication/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/projects",
    element: <ProjectsPage />,
  },
  {
    path: "/talents",
    element: <TalentsPage />,
  },
  {
    path: "/clients",
    element: <ClientsPage />,
  },
  {
    path: "/management",
    element: <ManagementPage />,
  },
  {
    path: "/communication",
    element: <CommunicationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
